import React, { useRef } from 'react';
import './SignaturePad.css';

// Lightweight finger/stylus signature pad (no external deps). Calls onChange
// with a PNG data URL as the person draws, or '' when cleared.
export default function SignaturePad({ onChange }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const last = useRef(null);

  const posFrom = (e) => {
    const c = canvasRef.current; const r = c.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    return { x: (p.clientX - r.left) * (c.width / r.width), y: (p.clientY - r.top) * (c.height / r.height) };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; last.current = posFrom(e); };
  const move = (e) => {
    if (!drawing.current) return; e.preventDefault();
    const ctx = canvasRef.current.getContext('2d'); const p = posFrom(e);
    ctx.strokeStyle = '#1a1f36'; ctx.lineWidth = 2.5; ctx.lineCap = 'round';
    ctx.beginPath(); ctx.moveTo(last.current.x, last.current.y); ctx.lineTo(p.x, p.y); ctx.stroke();
    last.current = p;
  };
  const end = () => { if (drawing.current) { drawing.current = false; onChange(canvasRef.current.toDataURL('image/png')); } };
  const clear = () => { const c = canvasRef.current; c.getContext('2d').clearRect(0, 0, c.width, c.height); onChange(''); };

  return (
    <div className="sigpad">
      <canvas ref={canvasRef} width={600} height={150} className="sigpad-canvas"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end} />
      <div className="sigpad-actions"><span>✍️ Sign with finger or stylus</span><button type="button" onClick={clear}>Clear</button></div>
    </div>
  );
}
